import { AuthError, NetworkError, ValidationError, errorFromResponse } from "./errors.js";

async function apiFetch(url, init = {}) {
  let response;
  try {
    response = await fetch(url, {
      credentials: "include",
      ...init,
      headers: { "Content-Type": "application/json", ...(init.headers || {}) },
    });
  } catch (err) {
    throw new NetworkError(`Failed to reach ${url}`, err);
  }
  if (!response.ok) throw await errorFromResponse(response);
  if (response.status === 204) return null;
  try {
    return await response.json();
  } catch (err) {
    throw new NetworkError(`Malformed JSON from ${url}`, err);
  }
}

export function getUsageAnalytics(periodDays = 30) {
  return apiFetch(`/api/admin/usage/analytics?periodDays=${encodeURIComponent(periodDays)}`);
}

export function getUsageUsers(periodDays = 30) {
  return apiFetch(`/api/admin/usage/users?periodDays=${encodeURIComponent(periodDays)}`);
}

export function getUserRecentActivity(userId, limit = 20) {
  return apiFetch(
    `/api/admin/usage/users/${encodeURIComponent(userId)}/activity?limit=${encodeURIComponent(limit)}`,
  );
}

export function getLoginHistory(filters = {}) {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(filters)) {
    if (value !== undefined && value !== null && value !== "") params.set(key, String(value));
  }
  return apiFetch(`/api/admin/usage/logins?${params.toString()}`);
}

export function getUserLoginHistory(userId, { page = 1, pageSize = 20 } = {}) {
  const params = new URLSearchParams({ page: String(page), pageSize: String(pageSize) });
  return apiFetch(
    `/api/admin/usage/users/${encodeURIComponent(userId)}/logins?${params.toString()}`,
  );
}

/**
 * Send one route-level event. The caller intentionally does not await this
 * promise; this client still rejects so callers can log failures in isolation.
 */
export function recordPageView(surface, object = {}) {
  return apiFetch("/api/usage-events/page-view", {
    method: "POST",
    body: JSON.stringify({
      surface,
      objectType: object.objectType ?? null,
      objectId: object.objectId ?? null,
    }),
  });
}

export function surfaceForPath(pathname) {
  const path = String(pathname || "");
  if (path.startsWith("/home")) return "home";
  if (path === "/") return "offices";
  if (path.startsWith("/offices")) return "offices";
  if (path.startsWith("/leases")) return "leases";
  if (path.startsWith("/markets")) return "markets";
  if (path.startsWith("/projects")) return "projects";
  if (path.startsWith("/reports")) return "reports";
  if (path.startsWith("/admin")) return "admin";
  if (path.startsWith("/radar") || path.startsWith("/infocus-radar")) return "radar";
  if (path.startsWith("/workflows")) return "workflows";
  if (path.startsWith("/playbooks")) return "playbooks";
  if (path.startsWith("/reviews")) return "reviews";
  if (path.startsWith("/start-here")) return "start_here";
  return "other";
}

export { AuthError, ValidationError };